import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";
import { getBuildVersion } from "../getDefaultHeaders";

export const linkBooking = async (
  bookingId: string,
  bookingIdToLink: string
): Promise<boolean> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.COLLINS_API_BASE_URL}/bookings/${bookingId}/linked`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Build-Version": getBuildVersion()
        },
        body: JSON.stringify({ bookings: [bookingIdToLink] })
      }
    );

    if (response.ok) {
      return true;
    }

    apiFetchNotOkHandler(response, "Error linking booking");
    return false;
  } catch (error) {
    errorHandler(error, "Error linking booking");
    return false;
  }
};

const stripDmnPrefix = (reference: string): string =>
  reference.replace(/^DMN-/i, "").trim();

export const lookupBookingByRef = async (
  reference: string,
  venueGroup: string
): Promise<string | null> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);
  const numericRef = stripDmnPrefix(reference);

  try {
    const response = await fetch(
      `${environmentVars?.COLLINS_API_BASE_URL}/bookings?booking_id=${encodeURIComponent(numericRef)}&venue_group=${encodeURIComponent(venueGroup)}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      const bookings = data.bookings ?? [];
      if (bookings.length === 0) {
        return null;
      }
      return bookings[0]._id ?? bookings[0].id ?? null;
    }

    apiFetchNotOkHandler(response, "Error looking up booking");
    return null;
  } catch (error) {
    errorHandler(error, "Error looking up booking");
    return null;
  }
};
